import { TitlePart as RawTitlePart } from '../atoms/TitlePart';
import { Logo as RawLogo } from '../atoms/Logo';

import { SingleLineText } from '../atoms/SingleLineText';
import { HrefLink as RawHrefLink } from '../atoms/HrefLink';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import logo from '../../assets/logo/bloomays_wordmark_logo.svg';
import { styled } from '@mui/material/styles';
import type { MouseEvent } from 'react';
import { Env } from '@bloomays-lib/types.shared';

interface FotterProps {
  release: string;
  env: Env;
  showLink?: boolean;
  logout?: () => void;
}

const Footer = ({ release, env, showLink = true, logout }: FotterProps) => {
  return (
    <ContainerFooter>
      {showLink && (
        <ContainerLink>
          <ContainerSection>
            <Logo image={logo} />
            <HrehSLT text="The Good Connection" />
            <HrefLink icon={<LinkedInIcon />} href="https://www.linkedin.com/company/bloomays/mycompany/" text={''} />
          </ContainerSection>
          <ContainerSection>
            <TitlePart variant="heading6" textTitle={'Dites-nous bonjour'} />
            <HrefLink text="bloomhelp@bloomays.com" href="mailto:bloomhelp@bloomays.com" />
            <HrehSLT text="128 rue la boétie, 75008 Paris, France" />
          </ContainerSection>
          <ContainerSection>
            <TitlePart variant="heading6" textTitle={'À propos'} />
            <HrefLink text="BloomHelp" href="https://bit.ly/bloomays-help" />
            <HrefLink text="Mentions légales" href="https://www.bloomays.com/legal-notice" />
            <HrefLink
              text="Préférences de cookies"
              onClick={(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                e.preventDefault();
                (window as any).Cookiebot?.show();
              }}
              href="#"
            />
            <HrefLink text="Supprimer mon compte" href="https://bloomays.typeform.com/to/oD1G99iX " />
            {logout ? (
              <HrefLink
                text="Se déconnecter"
                href="#"
                target="_self"
                onClick={(event: MouseEvent<HTMLAnchorElement>) => {
                  event.preventDefault();
                  logout();
                }}
              />
            ) : null}
          </ContainerSection>
        </ContainerLink>
      )}
      <ContainerVersion>
        <SingleLineText
          sx={{
            fontSize: '12px',
          }}
          text={`${new Date().getFullYear()} Bloomays v${release} ${env}`}
        />
      </ContainerVersion>
    </ContainerFooter>
  );
};

export default Footer;
export { Footer };

const HrefLink = styled(RawHrefLink)(({ theme }) => ({
  [theme.breakpoints.down(915)]: {
    justifyContent: 'center',
  },
}));

const HrehSLT = styled(SingleLineText)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  marginTop: '.4em',
  textDecoration: 'none',
  color: theme.palette.primary.main,
}));

const ContainerFooter = styled('div')(({ theme }) => ({
  display: 'flex',
  padding: '0',
  flexDirection: 'column',
  marginTop: 'auto', // Force le footer en bas
  width: '100%',
}));

const ContainerLink = styled('div')(({ theme }) => ({
  display: 'flex',
  flexFlow: 'row wrap',
  justifyContent: 'space-around',
  margin: '1em',
  gap: 20,
  [theme.breakpoints.down(915)]: {
    display: 'flex',
    flexDirection: 'column',
    margin: '1em auto',
  },
  [theme.breakpoints.down(500)]: {
    display: 'none',
  },
}));

const ContainerSection = styled('div')(({ theme }) => ({
  display: 'flex',
  flexFlow: 'column nowrap',
  justifyContent: 'left',
  alignContent: 'center',
  textAlign: 'left',
  [theme.breakpoints.down(915)]: {
    justifyContent: 'center',
  },
}));

const TitlePart = styled(RawTitlePart)(({ theme }) => ({
  textAlign: 'left',
  paddingTop: 0,
  [theme.breakpoints.down(915)]: {
    textAlign: 'center',
  },
}));

const Logo = styled(RawLogo)(({ theme }) => ({
  width: 180,
  paddingBottom: '0.7em',
  [theme.breakpoints.down(915)]: {
    margin: 'auto',
  },
}));

const ContainerVersion = styled('div')(({ theme }) => ({
  margin: '0.5em 0',
  textAlign: 'center',
}));
